module.exports = __webpack_public_path__ + "img/478543.bc17bdc9.svg";